export default __webpack_public_path__ + "static/shop-e7fb46cd0ac7c2eef9d278b87c707197.jpg";